import { render } from "./ReasonForm.vue?vue&type=template&id=9fa0d9ec"
import script from "./js/reasonForm.js?vue&type=script&lang=js&external"
export * from "./js/reasonForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__